import { icons } from '@/Icons';

function MaintenancePage() {
	return (
		<div
			className=" z-[10000000000000] fixed top-0 left-0 min-h-screen w-screen flex flex-col items-center justify-center gap-8 p-10 md:gap-24 md:p-2
					 bg-[rgb(57,86,161)]	bg-[url('/img/maintenance-background.webp')] bg-cover bg-center bg-no-repeat0"
		>
			<icons.mainlogoletters className="w-full max-w-[781.76px] max-h-[144.7px]" />
			<p className="text-center text-2xl md:text-[31.5px] md:leading-[42.093px] max-w-[800px] text-balance">
				Otherworld is currently down for maintenance. Please come back in a few
				minutes or contact support@otherworld.xyz for any immediate concerns.
			</p>
		</div>
	);
}

export default MaintenancePage;
